(function(){
'use strict';
var config=document.getElementById('sh-exact-search-config');
var text=config?JSON.parse(config.textContent):{};
function dimensions(value){
 var re=/(\d+(?:\.\d+)?)\s*["″]?\s*[x×]\s*(\d+(?:\.\d+)?)\s*["″]?(?:\s*[x×]\s*(\d+(?:\.\d+)?)\s*["″]?)?/gi;
 var match,out=[];
 while((match=re.exec(value))){
  if(match.index>0&&/[\d.]/.test(value[match.index-1]))continue;
  if(/[\d.]/.test(value[re.lastIndex]||''))continue;
  out.push(match.slice(1).filter(Boolean).map(Number).join('x'));
 }
 return out;
}
function exact(value){var sizes=dimensions(value);return sizes.length===1?sizes[0]:null;}
function matches(product,size){return dimensions(product.title).includes(size)||(product.variant_titles||[]).some(function(t){return dimensions(t).includes(size);});}
function query(size){
 var parts=size.split('x');
 return [...new Set([parts.join('x'),parts.join(' x '),parts.join('×'),parts.join(' × '),parts.join('" x ')+'"',parts.join(' x'),parts.join('x ')])].map(function(v){return 'title:"'+v.replace(/"/g,'\\"')+'" OR variants.title:"'+v.replace(/"/g,'\\"')+'"';}).join(' OR ');
}
async function find(value,signal){
 var size=exact(value);var base=query(size),page=1,all=[],seen=new Set();
 do{
  var url=new URL((window.Shopify&&Shopify.routes?Shopify.routes.root:'/')+'search',location.origin);
  url.searchParams.set('q',base);url.searchParams.set('type','product');url.searchParams.set('options[prefix]','none');
  url.searchParams.set('view','sh-exact');url.searchParams.set('page',page);
  var response=await fetch(url,{signal:signal,credentials:'same-origin'});
  if(!response.ok)throw new Error('Search unavailable');
  var data=await response.json();
  data.results.forEach(function(p){if(matches(p,size)&&!seen.has(p.url)){seen.add(p.url);all.push(p);}});
  page=data.next_page;
 }while(page);
 return {count:all.length,results:all};
}
function request(value,success,error){
 var controller=new AbortController();
 if(!exact(value))return window.jQuery.getJSON({url:(Shopify.routes?Shopify.routes.root:'/')+'search',data:{q:value,view:'json-2',type:'product'},success:success,error:error});
 find(value,controller.signal).then(success).catch(function(e){if(e.name!=='AbortError'&&error)error(e);});
 return {abort:function(){controller.abort();}};
}
window.SHExactSearch={dimensions:dimensions,exact:exact,matches:matches,query:query,find:find,request:request,errorText:text.error,emptyText:text.empty,defaultEmptyText:text.default_empty};
document.addEventListener('DOMContentLoaded',function(){
 var root=document.getElementById('sh-exact-search-results');if(!root)return;
 var value=new URLSearchParams(location.search).get('q')||'';if(!exact(value))return;
 document.querySelectorAll('[data-sh-standard-search]').forEach(function(el){el.hidden=true;});
 root.hidden=false;
 var title=document.createElement('h1');title.className='h3 mt-30 mb-20 text-center';title.textContent=text.heading+' '+value;root.appendChild(title);
 var status=document.createElement('p');status.className='text-center';status.setAttribute('role','status');status.textContent=text.loading;root.appendChild(status);
 find(value).then(function(data){
  document.title=text.heading+' '+value+' – supplyhut';
  status.textContent=data.count?(data.count===1?text.one:data.count+' '+text.count):text.empty;
  if(!data.count){var link=document.createElement('a');link.href=(Shopify.routes?Shopify.routes.root:'/')+'collections';link.textContent=text.browse;link.className='btn';status.appendChild(document.createElement('br'));status.appendChild(link);return;}
  var grid=document.createElement('div');grid.className='row mt-30';
  data.results.forEach(function(product){var cell=document.createElement('div');cell.className='col-12 col-sm-6 col-md-4 col-lg-3';cell.innerHTML=product.card;grid.appendChild(cell);});root.appendChild(grid);
  if(window.theme&&theme.ImagesLazyLoad)theme.ImagesLazyLoad.update();
  if(window.theme&&theme.ProductCurrency)theme.ProductCurrency.update();
 }).catch(function(){status.textContent=text.error;});
});
})();